import { useGetManufacturers } from '../useGetManufacturers';
import { useEffect, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useCarleadConfiguration } from '@wkda/carlead-creation-components';
export const useCuriousityDrivenEmailHeader = () => {
  const {
    values
  } = useFormState();
  const {
    country,
    fullLocale,
    hasCuriousityEmailHeadline = false
  } = useCarleadConfiguration();
  const [manufacturer, setManufacturer] = useState('');
  const {
    isLoading,
    isSuccess,
    data
  } = useGetManufacturers({
    country: country,
    locale: fullLocale
  });
  useEffect(() => {
    if (!isLoading && isSuccess) {
      setManufacturer(data['wkda'][values.manufacturer]);
    }
  }, [isLoading, isSuccess, data, values.manufacturer]);
  return {
    showCuriousityHeader: hasCuriousityEmailHeadline,
    manufacturer,
    mainType: values.mainType,
    builtDate: values.builtDate
  };
};